import { render, staticRenderFns } from "./urea.vue?vue&type=template&id=949ee782&"
import script from "./urea.vue?vue&type=script&lang=js&"
export * from "./urea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports